export default "__VITE_ASSET__e1ea4479__"